import { uploadData, remove } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';

// Handle file upload
export const handleUpload = async (file: File, UploadPath: string): Promise<string | undefined> => {
    const fileName = file.name;
    const key = `${UploadPath}/${uuidv4()}/${fileName}`;

    try {
        const result = await uploadData({
            key: key,
            data: file,
            options: {
                contentType: file.type,
                accessLevel: 'guest', // Adjust based on access requirements
            },
        });
        const urlKey = await result.result
        if(urlKey) {
            return urlKey.key;
        }
        throw new Error('Unexpected upload result format');
    } catch (error) {
        console.error('Upload Error:', error);
        return undefined;
    }
};

// Handle file deletion
export const handleDelete = async (filename: string): Promise<void> => {
    try {
        const val = await remove({
            key: filename, // Pass the correct file key
        });
    } catch (error) {
        console.error('Delete Error:', error);
    }
};
